"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userTypes = exports.userReducer = exports.userAction = void 0;
const user_component_1 = __importDefault(require("./sub-components/user.component"));
const user_action_1 = __importDefault(require("./user.action"));
exports.userAction = user_action_1.default;
const user_reducer_1 = __importDefault(require("./user.reducer"));
exports.userReducer = user_reducer_1.default;
const user_types_1 = require("./user.types");
Object.defineProperty(exports, "userTypes", { enumerable: true, get: function () { return user_types_1.userTypes; } });
exports.default = user_component_1.default;
